export default __webpack_public_path__ + "static/media/rednessActive.83264469.svg";